//import Some from './js/exampl';
import './css/style.less';
import Main from './js/main';
import Map from './js/map';
import VideoInit from './js/video';
import Gallery from './js/gallery';
import Carousel from './js/carousel';
import Scroll from './js/scroll';
import $ from "jquery";
//import Rent from './js/rent';
require('es6-promise').polyfill();

//import logo from './img/logo.png';

Main.Init();

const map_content = document.querySelector('.map-main');
if(map_content){
    Map.Init();
}

const video_js = document.querySelector('.video-js');
if(video_js){
    VideoInit.Init();
}

const gallery = document.querySelector('[data-fancybox]');
if(gallery){
    Gallery.Init();
}

const carousel = document.querySelector('[data-carousel]');
if(carousel){
    Carousel.Init();
}

const scroll = document.querySelector('[data-scroll]');
if(scroll){
    Scroll.Init();
}